module.exports = __webpack_public_path__ + "img/56b67.75ef1bb4.svg";